var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagedGcpDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_80",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#bbb",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_gcp_storage_table-disabled",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2, -2)",
    filter: "url(#Ellipse_80)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80-2",
    "data-name": "Ellipse 80",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(2 2)",
    fill: "#fbfbfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11037",
    "data-name": "Group 11037",
    transform: "translate(10 11.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M14.209,4.393h.063l-.038-.031L16.616,1.98l0-.043a7.742,7.742,0,0,0-12.6,3.777.971.971,0,0,1,.128-.042,5.555,5.555,0,0,1,4.138-.82.072.072,0,0,1,.05-.013,4.3,4.3,0,0,1,5.881-.447h-.012",
    transform: "translate(-1.634 0)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M24.09,7.044a7.78,7.78,0,0,0-2.339-3.77L19.333,5.691A4.3,4.3,0,0,1,20.911,9.1v.428a2.152,2.152,0,0,1,0,4.3h-4.3l-.007.007v3.415h-.018l.025.025h4.3A5.6,5.6,0,0,0,24.09,7.044",
    transform: "translate(-6.733 -1.329)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M7.059,24.325h4.3V20.881h-4.3a2.112,2.112,0,0,1-.884-.194L3.687,23.175l-.007.026a5.572,5.572,0,0,0,3.378,1.124",
    transform: "translate(-1.495 -8.4)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M5.565,8A5.6,5.6,0,0,0,2.186,18.028l2.5-2.5a2.151,2.151,0,1,1,2.846-2.847l2.5-2.5A5.592,5.592,0,0,0,5.565,8",
    transform: "translate(0 -3.246)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedGcpDisabled);
export default __webpack_public_path__ + "static/media/managed-gcp-disabled.ecf5cbbd40901ac67a9644b9cff42295.svg";
export { ForwardRef as ReactComponent };